import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchComparisonDocumentIssues(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_COMPARISON_DATA_FETCH,
    (organisationId, projectId, documentId) => {
      // TODO rename comparison_document_issues to issue_comparison_data (and
      // getDocuments rest call) when merged to master
      const reqString = `${basePath}/organisation/${organisationId}/project/${projectId}
        /document/${documentId}?comparison_document_issues=true`;
      return requestor
        .get(reqString, {withCredentials: true})
        .then(response => ({
          organisation_id: parseInt(organisationId, 10),
          project_id: parseInt(projectId, 10),
          document_id: parseInt(documentId, 10),
          ...response.data,
        }));
    },
  );
}
